// Session management utility for poker-admin-web

const SESSION_STORAGE_KEY = 'poker_admin_session';
const SESSION_EXPIRY_HOURS = 24;

/**
 * Save user session to localStorage
 * @param {Object} userData - User data to save
 */
export const saveSession = (userData) => {
  try {
    const sessionData = {
      user: userData,
      timestamp: new Date().getTime()
    };
    localStorage.setItem(SESSION_STORAGE_KEY, JSON.stringify(sessionData));
    console.log('Session saved:', userData.username);
    return true;
  } catch (error) {
    console.error('Error saving session:', error);
    return false;
  }
};

/**
 * Load user session from localStorage
 * @returns {Object|null} User data or null if no valid session
 */
export const loadSession = () => {
  try {
    const sessionData = localStorage.getItem(SESSION_STORAGE_KEY);
    if (!sessionData) {
      return null;
    }

    const { user, timestamp } = JSON.parse(sessionData);

    // Check if session is expired
    const now = new Date().getTime();
    const expiryTime = SESSION_EXPIRY_HOURS * 60 * 60 * 1000;

    if (now - timestamp < expiryTime) {
      console.log('Session restored:', user.username);
      return user;
    } else {
      // Session expired, clear it
      clearSession();
      console.log('Session expired, cleared');
      return null;
    }
  } catch (error) {
    console.error('Error loading session:', error);
    clearSession();
    return null;
  }
};

/**
 * Clear user session from localStorage
 */
export const clearSession = () => {
  try {
    localStorage.removeItem(SESSION_STORAGE_KEY);
    console.log('Session cleared');
    return true;
  } catch (error) {
    console.error('Error clearing session:', error);
    return false;
  }
};

/**
 * Check if user session exists and is valid
 * @returns {boolean}
 */
export const hasValidSession = () => {
  const user = loadSession();
  return user !== null;
};

/**
 * Get current session user
 * @returns {Object|null}
 */
export const getCurrentUser = () => {
  return loadSession();
};

/**
 * Update session timestamp (refresh session)
 */
export const refreshSession = () => {
  try {
    const sessionData = localStorage.getItem(SESSION_STORAGE_KEY);
    if (sessionData) {
      const { user } = JSON.parse(sessionData);
      saveSession(user); // Re-save with new timestamp
      return true;
    }
    return false;
  } catch (error) {
    console.error('Error refreshing session:', error);
    return false;
  }
};
